import React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchers } from "../lib/api";
import NewsCard from "../components/NewsCard";
import AdSlot from "../components/AdSlot";

export default function News() {
  const { data } = useQuery({ queryKey: ["news-page"], queryFn: () => fetchers.news({ limit: 50 }) });
  const items = data?.items || [];
  const feature = items[0];
  const row2 = items.slice(1, 3);
  const row3 = items.slice(3, 7);
  const row4 = items.slice(7);

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
      <div className="mb-6">
        <div className="overline-eyebrow text-primary">The Pulse</div>
        <h1 className="font-display text-5xl uppercase leading-none sm:text-6xl">News & Features</h1>
        <p className="mt-3 max-w-2xl text-sm text-muted-foreground">
          Deep dives, breaking stories, and sharp opinion from our editorial team.
        </p>
      </div>

      <AdSlot size="leaderboard" slotId="news-top" className="mb-8 hidden md:flex" />
      <AdSlot size="large_mobile" slotId="news-top-m" className="mb-8 md:hidden" />

      {feature && (
        <div className="grid gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <NewsCard article={feature} size="xl" />
          </div>
          <aside className="space-y-5 lg:col-span-4">
            {row2.map((a) => (
              <NewsCard key={a.id} article={a} size="sm" />
            ))}
            <AdSlot size="rectangle" slotId="news-side-1" />
          </aside>
        </div>
      )}

      <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {row3.map((a) => (
          <NewsCard key={a.id} article={a} />
        ))}
      </div>

      <div className="my-10">
        <AdSlot size="billboard" slotId="news-middle" className="hidden lg:flex" />
        <AdSlot size="responsive" slotId="news-middle-m" className="lg:hidden" />
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {row4.map((a) => (
          <NewsCard key={a.id} article={a} />
        ))}
      </div>

      <div className="mt-10">
        <AdSlot size="billboard" slotId="news-bottom" className="hidden lg:flex" />
        <AdSlot size="responsive" slotId="news-bottom-m" className="lg:hidden" />
      </div>
    </div>
  );
}
